<template>
  <div
    :style="`
      transform: rotate(${rotation}deg);
      left: ${positionX}%;
      top: ${positionY}%;
    `"
    :class="[
      borderColor,
      { 'arc-el--fade-in': fadeIn }
    ]"
    class="arc-el"
  />
</template>

<script>
import VueTypes from 'vue-types'
import checkViewport from 'beisheim/mixins/check-viewport'

export default {
  mixins: [checkViewport],
  props: {
    parallax: VueTypes.bool,
    borderColor: VueTypes.string,
    rotation: VueTypes.integer,
    positionX: VueTypes.integer,
    positionY: VueTypes.integer
  },
  data () {
    return {
      fadeIn: false
    }
  },
  watch: {
    elBoundingRect () {
      if (!this.inParallaxRange) { return }
      let offsetValue = Math.floor(this.elBoundingRect.y / 5)
      if (offsetValue > 200) { offsetValue = 200 }
      let rotationOffset = Math.floor(this.elBoundingRect.top / 10)
      if (rotationOffset <= 0) { rotationOffset = 0 }
      this.$el.style.transform = `rotate(${this.rotation - rotationOffset}deg)`
    }
  },
  mounted () {
    let offsetValue = Math.max(Math.floor(this.elBoundingRect.y / 5), 100)
    if (offsetValue > 200) { offsetValue = 200 }
    let rotationOffset = Math.floor(this.elBoundingRect.top / 10)
    if (rotationOffset <= 0) { rotationOffset = 0 }
    this.$el.style.transform = `rotate(${this.rotation - rotationOffset}deg)`
    this.fadeIn = true
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/breakpoints';

$border-size: 25;
$border-size-mobile: 15;

.arc-el {
  position: absolute;
  width: scale($border-size-mobile);
  height: scale($border-size-mobile * 2);
  border: solid 1px;
  border-top-left-radius: scale($border-size-mobile);
  border-bottom-left-radius: scale($border-size-mobile);
  border-right: 0;
  transform-origin: right center;
  transition: transform 100ms linear, opacity 600ms ease-out;
  will-change: transform;
  opacity: 0;

  @include from(4) {
    width: scale($border-size);
    height: scale($border-size * 2);
    border-top-left-radius: scale($border-size);
    border-bottom-left-radius: scale($border-size);
    border: solid 2px;
    border-right: 0;
  }

  &--fade-in {
    opacity: 1;
  }

  &--bildung {
    border-color: brand(3);
  }
  &--gesundheit {
    border-color: brand(4);
  }
  &--kultur {
    border-color: brand(1);
  }
  &--sport {
    border-color: brand(2);
  }
}
</style>
